module.exports = __webpack_public_path__ + "img/product.f8f66739.png";